export const LS_DARK_MODE_KEY = 'isDarkModeEnabled';
